import { Injectable } from '@angular/core';

export interface AccountListGroup {
  groupId: string;
  label: string;
}

@Injectable({
  providedIn: 'root'
})
export class AccountsListGroupsConfigService {
  private _accountsListGroups: AccountListGroup[] = [
    { groupId: 'current-accounts', label: 'Current Accounts' },
    { groupId: 'savings-accounts', label: 'Savings Accounts' },
    { groupId: 'loan-accounts', label: 'Loan Accounts' }
  ];

  getAccountsListGroups(): AccountListGroup[] {
    return this._accountsListGroups;
  }

  setAccountsListGroups(groups: AccountListGroup[]): void {
    this._accountsListGroups = groups;
  }
}

